export default "__VITE_ASSET__C1mMnt2N__"